export default {
	IMAGES:
		'https://www.googleapis.com/customsearch/v1?key=AIzaSyCzNxcar8fTntpF0Tn9mhU0HpNU6ZCHJgM&cx=003313481002708032076:2883xbbjvre&searchType=image',
};
